
  import { computed, defineComponent } from 'vue';
  import { Colour } from '../../../helpers/colour';
  import './label.scss';

  /**
    * Form label
    * 
    * @example
    * <code>import TpxLabel from '@manifesto-tech/tpximpact-design-system/components/atoms/form/label.vue'</code>
    */
  export default defineComponent({
    name: 'TpxLabel',
    
    props: {
      /**
         * Label colour
         */
      colour: {
        default: Colour.Blue,
        type: String,
        validator: (value) => {
          return Object.values(Colour).includes(value as Colour);
        },
      },

      /**
       * Content/Copy of the label
       */
      content: {
        required: true,
        type: String,
      },

      /**
       * ID of the associated form field
       */
      for: {
        type: String,
      },

      /**
       * Should we show the 'required' marker
       */
      isRequired: {
        type: Boolean,
      },
    },
    
    data() {
      return {
        colourClasses: computed(() => ({
          [`text--${this.colour}`]: !!this.colour,
        })),
      };
    },
  });
